
<template>
  <div>
    <v-main>

      <div v-if="resCol === '12' && showScanner === false">
        <v-container>
          <div>

            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="padding-top: 20px">
                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <v-row>
                    <v-col cols="12">
                      <h2 class="text-h">เพิ่มคะแนน</h2>
                    </v-col>
                    <v-col cols="12" style="padding: 0px 0px">

                      <v-text-field v-model="formAdd.tel"
                          :label="isChubb ? 'รหัสพนักงาน' : 'เบอร์โทรศัพท์'"
                          v-mask="telMask"
                          :rules="isChubb ? [rules.empId] : [rules.required]"
                          :placeholder="isChubb ? 'Ex. AA12345' : ''"
                          solo required append-icon="mdi-qrcode-scan"
                          @click:append="scanQrcodePhoneNumber()"></v-text-field>
                    </v-col>
                    <v-col cols="12" style="padding: 0px 0px">
                      <v-select v-show="ProductExchangeRate.length > 1" v-model="formAdd.productExchangeRateId"
                        label="อัตราแลกเปลี่ยน" solo :items="ProductExchangeRate" :rules="[rules.required]"
                        :menu-props="{ bottom: true, offsetY: true }" required></v-select>
                    </v-col>
                    <v-col cols="12" style="padding: 0px 0px">
                      <v-text-field v-model="formAdd.amount" label="จำนวนเงิน (บาท)" type="number" :min="0" solo
                        :rules="[rules.required, rules.nonNegative]" required></v-text-field>
                    </v-col>

                    <v-col cols="12" style="padding: 0px 0px" v-if="formAdd.masBranchID">
                      <v-select v-model="formAdd.masBranchID" label="สาขา" solo :items="dataBranch"
                        :rules="[rules.required]" :menu-props="{ bottom: true, offsetY: true }" required></v-select>
                    </v-col>
                    <v-col cols="12" style="padding: 0px 0px">
                      <v-text-field v-model="formAdd.refId" label="หมายเหตุ" solo></v-text-field>
                    </v-col>
                    <v-col cols="12" class="padding-colH" style="padding-bottom: 8%">
                      <v-btn block large :loading="loading" color="#1b437c" dark
                        @click="validate(), addCoin()">เพิ่มคะแนน
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-container>
      </div>
      <div style="overflow-x: hidden" v-if="resCol === '6'">
        <v-row style="padding: 1% 1%; height: 100px">
          <v-col>
            <h2>เพิ่มคะแนน</h2>
          </v-col>
          <v-col class="text-right" >
            <v-btn color="success" @click="dialogimportPoint = true"
              >นำเข้าคะแนนผ่าน Excel</v-btn
            >
            <v-btn v-if="isChubb" color="success" @click="dialogimportPointFixPoint = true"
              >นำเข้าคะแนนผ่าน Excel (ระบุคะแนน)</v-btn
            >
          </v-col>
        </v-row>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="padding-top: 20px">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <h2>
                      1. กรอกข้อมูล ( <span style="color: red">*</span> จำเป็น )
                      และกดปุ่มตรวจสอบ
                    </h2>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-select v-model="formAdd.productExchangeRateId" label="อัตราแลกเปลี่ยน" outlined
                      :items="ProductExchangeRate" :rules="[rules.required]"
                      :menu-props="{ bottom: true, offsetY: true }" required></v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <div style="color: cornflowerblue; margin-left: 17px">
                      **ถ้าจำนวนเงินเป็นทศนิยมจะถูกปัดทศนิยมลงแล้วคิดคะแนน
                    </div>
                    <v-text-field v-model="formAdd.amount" label="จำนวนเงิน (บาท)" type="number" :min="0" outlined
                      :rules="[rules.required, rules.nonNegative]" required></v-text-field>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-text-field v-if="!isChubb" v-model="formAdd.tel" label="เบอร์โทรศัพท์" v-mask="'###-###-####'" :rules="[rules.required]"
                      placeholder="" outlined required></v-text-field>
                    <v-text-field v-if="isChubb" v-model="formAdd.tel" label="รหัสพนักงาน" :rules="[rules.empId]" placeholder="Ex. AA12345"
                      outlined required></v-text-field>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-select v-model="formAdd.masBranchID" label="สาขา" outlined :items="dataBranch"
                      @change="onBranchChange"
                      :rules="[rules.required]" :menu-props="{ bottom: true, offsetY: true }" required></v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-select :items="referenceNumberItems" v-model="selectedReferenceNumber" item-text="value"
                      item-value="key" label="ลักษณะข้อมูลอ้างอิง" outlined></v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-text-field v-if="selectedReferenceNumber === 1" v-model="formAdd.refId" label="เลขอ้างอิง"
                      outlined></v-text-field>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" style="padding: 0px 0px">
                    <v-file-input v-if="selectedReferenceNumber === 2" class="mt-0" v-model="uploadedFile"
                      prepend-icon="" accept=".jpg,.png,.pdf" :show-size="uploadedFile !== null"
                      :counter="uploadedFile !== null" outlined label="แนบไฟล์เอกสาร"
                      :rules="[rules.file]"></v-file-input>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="padding-colH" style="padding-bottom: 8%">
                    <v-btn :disabled="!valid" block large color="primary" @click="validate(), addData()">ตรวจสอบ
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <h2>2.ตรวจสอบข้อมูลลูกค้า และกดปุ่ม เพิ่มคะแนน</h2>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-card max-width="460" style="height: auto">
                      <v-row v-if="formProfile.memberId === ''">
                        <v-col class="text-center">
                          <h2>ตรวจสอบข้อมูลลูกค้า</h2>
                        </v-col>
                      </v-row>
                      <v-col class="text-center">
                        <v-avatar color="primary" size="120">
                          <img :src="formProfile.picture !== ''
                              ? formProfile.picture
                              : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                            " />
                        </v-avatar>
                        <v-card-title class="text-h5">
                          <v-col class="text-center" style="padding-bottom: 0px">
                            {{
                              formProfile.name
                                ? formProfile.name
                                : "สมชาย สีสะอาด"
                            }}
                          </v-col>
                        </v-card-title>
                      </v-col>

                      <v-container>
                        <v-row>
                          <v-col class="text-start" style="color: #4a4a4a; padding-bottom: 0px">ชื่อ-สกุล</v-col>
                          <v-col class="text-end" style="padding-bottom: 0px">{{
                            formProfile.nameCustomer
                              ? formProfile.nameCustomer
                              : "-"
                          }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-start" style="color: #4a4a4a; padding-bottom: 0px">
                            {{
                              isChubb ? "รหัสพนักงาน" : "เบอร์โทรศัพท์"
                            }}</v-col>
                          <v-col class="text-end" style="padding-bottom: 0px">{{
                            formProfile.tel ? formProfile.tel : "-"
                          }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-start" style="color: #4a4a4a; padding-bottom: 0px">ระดับ</v-col>
                          <v-col class="text-end" style="padding-bottom: 0px">{{
                            formProfile.LevelName ? formProfile.LevelName : "-"
                            }}</v-col>
                        </v-row>
                        <v-row v-if="showInviter">
                          <v-col cols="3" class="text-start" style="color: #4a4a4a; padding-bottom: 0px">
                            <p class="mb-0">ผู้แนะนำ</p>
                            <v-avatar>
                              <img :src="inviterData.picture" alt="John" />
                            </v-avatar>
                          </v-col>
                          <v-col cols="1"> </v-col>
                          <v-col cols="4" class="text-start" style="
                              color: #4a4a4a;
                              padding-bottom: 0px;
                              display: flex;
                              align-items: center;
                              text-wrap: nowrap;
                              padding-left: 0px;
                            ">{{ inviterData.name }}</v-col>
                          <v-col cols="4" class="text-start" style="
                              color: #4a4a4a;
                              padding-bottom: 0px;
                              display: flex;
                              align-items: center;
                              text-wrap: nowrap;
                              justify-content: end;
                            "><v-btn color="rgb(24 118 210)" rounded dark @click="dialogReferalMember = true">
                              ดูข้อมูล
                              <v-icon class="ml-1">mdi-account-search</v-icon>
                            </v-btn></v-col>
                        </v-row>
                      </v-container>

                      <v-divider class="my-3" style="padding-top: 0; margin: 0px 0px"></v-divider>

                      <v-container>
                        <v-row class="d-flex justify-content-between">
                          <v-col style="padding-bottom: 0px">
                            <h3 style="font-size: 16px !important" class="text-left">
                              คะแนนที่ต้องการแจก
                            </h3>
                          </v-col>
                          <v-col style="padding-bottom: 0px">
                            <h3 style="font-size: 16px !important" class="text-right">
                              <!-- {{formProfile.point}} -->
                              {{
                                formProfile.points
                                  ? formatNumber(formProfile.points) + " คะแนน"
                                  : "- คะแนน"
                              }}

                              <v-chip x-small color="green" text-color="white" class="mb-1" v-if="this.multiplyPoint">{{
                                this.multiplyPoint
                                  ? `คะแนนคูณ ` + this.multiplyPoint
                                  : ""
                              }}</v-chip>
                            </h3>
                          </v-col>
                        </v-row>
                        <v-row class="d-flex justify-content-between">
                          <v-col>
                            <h3 style="font-size: 16px !important" class="text-left">
                              คะแนนคงเหลือ
                            </h3>
                          </v-col>
                          <v-col>
                            <h2 style="font-size: 16px !important" class="text-right">
                              {{
                                formProfile.point
                                  ? formatNumber(formProfile.point) + " คะแนน"
                                  : "- คะแนน"
                              }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-card-text>
                        <v-row>
                          <v-col></v-col>
                          <v-col></v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <div>
                          <v-btn color="#f74569" dark @click="
                            (dialog = false), (confirmBtn = true)
                          reset(),
                            clear(),
                            getProductExchangeRate(),
                            getDataBranch()
                          " v-if="formProfile.memberId !== ''">
                            ยกเลิก
                          </v-btn>
                          <v-btn color="#25D252" :loading="loadingAdd" dark @click="confirm(), confirm === true"
                            v-if="formProfile.memberId !== ''">
                            เพิ่มคะแนน
                          </v-btn>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <v-dialog v-model="dialogReferalMember" v-if="inviterData" persistent max-width="370">
          <v-card class="mx-auto" max-width="370">
            <v-card-title class="pa-3" style="justify-content: center">ข้อมูลผู้แนะนำ</v-card-title>

            <v-card-subtitle class="pb-0 pa-4" style="display: flex; justify-content: center">
              <v-avatar size="90">
                <img :src="inviterData.picture" alt="John" />
              </v-avatar>
            </v-card-subtitle>

            <v-card-text class="text--primary pa-3">
              <v-card class="px-4 pt-4">
                <v-row>
                  <v-col style="justify-content: end; display: flex">
                    ชื่อ-สกุล :
                  </v-col>
                  <v-col>
                    {{ inviterData.nameCustomer }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="justify-content: end; display: flex">
                    {{
                      isChubb ? "รหัสพนักงาน" : "เบอร์โทรศัพท์"
                    }}
                    :
                  </v-col>
                  <v-col>
                    {{ inviterData.tel }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="justify-content: end; display: flex">
                    ระดับสมาชิก :
                  </v-col>
                  <v-col>
                    {{ inviterData.LevelName }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="justify-content: end; display: flex">
                    คะแนนปัจจุบัน :
                  </v-col>
                  <v-col>
                    {{ formatNumber(inviterData.currentPoint) }} คะแนน
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="red" style="color: white !important" @click="dialogReferalMember = false">
                ปิด
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogimportPoint" persistent max-width="50%">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <h2>นำเข้าข้อมูลคะแนนผ่าน Excel</h2>
                </v-col>
                <v-col class="text-right">
                  <v-btn small color="#E0E0E0" @click="(dialogimportPoint = false), clearDataPoint()">
                    <v-icon color="#173053">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn dark color="#1b437c" @click="exportToExcel1">
                    <!-- <download-excel
                      :data="export_datas"
                      :fields="export_fields"
                      :type="exportType"
                      :worksheet="exportWorksheet"
                      :name="exportFileName"
                    > -->
                    ดาวน์โหลดเอกสาร
                    <!-- </download-excel> -->
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <input ref="fileInput" type="file" @change="importData" accept=".xls,.xlsx" />
                </v-col>
              </v-row>
              <v-form ref="form">
                <v-row>
                  <v-col>
                    <v-select v-model="importPoint.productExchangeRateId" label="อัตราแลกเปลี่ยน" outlined dense
                      :items="ProductExchangeRate" :rules="[rules.required]"
                      :menu-props="{ bottom: true, offsetY: true }" required
                      @change="checkSelectExchangeRate = true"></v-select>
                  </v-col>
                  <v-col>
                    <v-select v-model="importPoint.masBranchID" label="สาขา" dense outlined :items="dataBranch"
                      :rules="[rules.required]" :menu-props="{ bottom: true, offsetY: true }" required
                      @change="checkSelectBranch = true"></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-row>
                <v-col cols="12">
                  <p>
                    หมายเหตุ : ระบบจะไม่แจกคะแนนให้เบอร์โทรศัพท์ที่มีสถานะ
                    พบบัญชีผู้ใช้ซ้ำ หรือ ไม่พบบัญชีผู้ใช้
                  </p>
                  <p style="color: red" v-if="checkDupNotdecress()">ยอดค่าใช้จ่ายห้ามติดลบ กรุณาตรวจสอบข้อมูล</p>
                  <v-card>
                    <template>
                      <v-data-table :headers="columnsImport" :items="dataItemImport" :items-per-page="5"
                        :sort-by="['status']" :sort-desc="[true]" style="text-align: center">
                        <template v-slot:[`item.status`]="{ item }">
                          <v-chip color="red" outlined v-if="item.status === 'False'">ไม่พบบัญชีผู้ใช้</v-chip>
                          <v-chip color="green" outlined v-if="item.status === 'True'">พบบัญชีผู้ใช้</v-chip>
                          <!-- <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'True'"
                              >True</v-chip
                            > -->
                        </template>
                        <template v-slot:[`item.statusDup`]="{ item }">
                          <v-chip color="red" outlined v-if="item.statusDup === 'False'">ซ้ำ</v-chip>
                          <!-- <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'True'"
                              >True</v-chip
                            > -->
                        </template>
                      </v-data-table>
                      <!-- <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          :sort-by="['status']"
                          :sort-desc="[true]"
                        >
                          <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'ไม่พบรายชื่อ'"
                              >ไม่พบรายชื่อ</v-chip
                            >
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'พบรายชื่อซ้ำ'"
                              >พบรายชื่อซ้ำ</v-chip
                            >
                            <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'พบรายชื่อลูกค้า'"
                              >พบรายชื่อลูกค้า</v-chip
                            >
                          </template>
                        </v-data-table> -->
                    </template>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-right">
                  <v-btn color="error" @click="clearDataPoint()">ยกเลิก</v-btn>
                  <v-btn
                    v-if="!isChubb"
                    color="success"
                    :disabled="!checkSelectExchangeRate || !checkSelectBranch || checkDupOrnotfimd() || checkDupNotdecress4()"
                    @click="submitpoint()"
                    >เพิ่มคะแนน</v-btn
                  >
                  <v-btn
                    v-else
                    color="success"
                    :disabled="!checkSelectExchangeRate || !checkSelectBranch || checkDup() || checkDupNotdecress() || checkDupNotdecress4()"
                    @click="submitpoint()"
                    >เพิ่มคะแนน</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogimportPointFixPoint" persistent max-width="50%">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <h2>นำเข้าข้อมูลคะแนนผ่าน Excel (ระบุคะแนน)</h2>
                </v-col>
                <v-col class="text-right">
                  <v-btn small color="#E0E0E0" @click="
                    (dialogimportPointFixPoint = false), clearDataPoint()
                    ">
                    <v-icon color="#173053">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn dark color="#1b437c" @click="exportToExcel">
                    <!-- <download-excel
                      :data="export_datas2"
                      :fields="export_fields2"
                      :type="exportType"
                      :worksheet="exportWorksheet"
                      :name="exportFileName2"
                    > -->
                    ดาวน์โหลดเอกสาร
                    <!-- </download-excel> -->
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <input ref="fileInput" type="file" @change="importData" accept=".xls,.xlsx" />
                </v-col>
              </v-row>
              <v-form ref="form">
                <v-row>
                  <!-- <v-col>
                    <v-select
                      v-model="importPoint.productExchangeRateId"
                      label="อัตราแลกเปลี่ยน"
                      outlined
                      dense
                      :items="ProductExchangeRate"
                      :rules="[rules.required]"
                      :menu-props="{ bottom: true, offsetY: true }"
                      required
                      @change="checkSelectExchangeRate = true"
                    ></v-select>
                  </v-col> -->
                  <v-col>
                    <v-select v-model="importPoint.masBranchID" label="สาขา" dense outlined :items="dataBranch"
                      :rules="[rules.required]" :menu-props="{ bottom: true, offsetY: true }" required
                      @change="checkSelectBranch = true"></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-row>
                <v-col cols="12">
                  <p>
                    หมายเหตุ : ระบบจะไม่แจกคะแนนให้เบอร์โทรศัพท์ที่มีสถานะ
                    พบบัญชีผู้ใช้ซ้ำ หรือ ไม่พบบัญชีผู้ใช้
                  </p>
                  <p style="color: red" v-if="checkDupNotdecress2()">คะแนนห้ามติดลบ กรุณาตรวจสอบข้อมูล</p>
                  <v-card>
                    <template>
                      <v-data-table :headers="columnsImport2" :items="dataItemImport" :items-per-page="5"
                        :sort-by="['status']" :sort-desc="[true]" style="text-align: center">
                        <template v-slot:[`item.status`]="{ item }">
                          <v-chip color="red" outlined v-if="item.status === 'False'">ไม่พบบัญชีผู้ใช้</v-chip>
                          <v-chip color="green" outlined v-if="item.status === 'True'">พบบัญชีผู้ใช้</v-chip>
                          <!-- <v-chip
                              color="green"
                              outlined
                              >True</v-chip
                            > -->
                        </template>
                        <template v-slot:[`item.statusDup`]="{ item }">
                          <v-chip color="red" outlined v-if="item.statusDup === 'False'">ซ้ำ</v-chip>
                          <!-- <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'True'"
                              >True</v-chip
                            > -->
                        </template>
                      </v-data-table>
                      <!-- <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          :sort-by="['status']"
                          :sort-desc="[true]"
                        >
                          <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'ไม่พบรายชื่อ'"
                              >ไม่พบรายชื่อ</v-chip
                            >
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'พบรายชื่อซ้ำ'"
                              >พบรายชื่อซ้ำ</v-chip
                            >
                            <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'พบรายชื่อลูกค้า'"
                              >พบรายชื่อลูกค้า</v-chip
                            >
                          </template>
                        </v-data-table> -->
                    </template>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-right">
                  <v-btn color="error" @click="(dialogimportPointFixPoint = false), clearDataPoint()">ยกเลิก</v-btn>
                  <v-btn
                    color="success"
                    :disabled="!checkSelectBranch || checkDupOrnotfimd() || checkDupNotdecress2() || checkDupNotdecress3()"
                    @click="submitpointFixPoint()"
                    >เพิ่มคะแนน</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="dialogImport" persistent max-width="50%">
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <h2>นำเข้าข้อมูลคะแนนผ่าน Excel</h2>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn small color="#E0E0E0" @click="dialogImport = false">
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <input type="file" @change="importData" accept=".xls,.xlsx" />
                  </v-col>
                </v-row>
                <v-form ref="form">
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="importPoint.productExchangeRateId"
                        label="อัตราแลกเปลี่ยน"
                        outlined
                        dense
                        :items="ProductExchangeRate"
                        :rules="[rules.required]"
                        :menu-props="{ bottom: true, offsetY: true }"
                        required
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="importPoint.amount"
                        label="จำนวนเงิน (บาท)"
                        dense
                        type="number"
                        :min="0"
                        outlined
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="importPoint.masBranchID"
                        label="สาขา"
                        dense
                        outlined
                        :items="dataBranch"
                        :rules="[rules.required]"
                        :menu-props="{ bottom: true, offsetY: true }"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <template>
                        <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          :sort-by="['status']"
                          :sort-desc="[true]"
                        >
                          <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'False'"
                              >False</v-chip
                            >
                            <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'True'"
                              >True</v-chip
                            >
                          </template>
                        </v-data-table>
                      </template>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-right">
                    <v-btn color="success" @click="importDataPoint">ยืนยัน</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog> -->
      </div>
      <div v-if="showScanner">
        <v-icon large dark @click="stopScan" style="position: absolute; z-index: 999; padding: 5px">mdi-close</v-icon>
        <StreamBarcodeReader @decode="(a) => onDecode(a)"></StreamBarcodeReader>
        <div style="display: flex; justify-content: center">
          <p style="
              color: #adadac;
              font-size: 18px !important;
              padding-top: 10px;
            ">
            คุณสามารถสแกนคิวอาร์โค้ดเพื่อรับเบอร์โทรศัพท์
          </p>
        </div>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { StreamBarcodeReader } from 'vue-barcode-reader'
// import constants from '@/constants.js'

export default {
  components: {
    StreamBarcodeReader,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  computed: {
    isChubb () {
      return this.shopNameData && this.$session.getAll().data.shopId === this.shopNameData.SHOP_ID_CHUBB
    },
    telMask () {
      return this.isChubb ? '' : '###-###-####'
    },
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    }
  },
  data () {
    return {
      uploadedFile: null,
      picture: '',
      selectedReferenceNumber: 1,
      referenceNumberItems: [
        { key: 1, value: 'เลขอ้างอิง' },
        { key: 2, value: 'แนบไฟล์เอกสาร' }
      ],
      aa: '',
      dataNew: null,
      multiplyPoint: null,
      session: this.$session.getAll(),
      path: '/AddCoin/', // Path Model
      returnLink: '/Master/AddCoin',
      valid: true,
      dialogReferalMember: false,
      dialogImport: false,
      dialogimportPoint: false,
      dialogimportPointFixPoint: false,
      profile: false,
      statusnotifyAddcoin: null,
      inviterData: null,
      showInviter: false,
      formAdd: {
        productExchangeRateId: '',
        amount: '',
        tel: '',
        masBranchID: '',
        refId: '',
        point: '',
        token: '',
        status: 'waiting',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        CREATE_DATE: ''
      },
      formProfile: {
        picture: '',
        name: '',
        tel: '',
        point: '',
        totalpoint: '',
        LevelName: '',
        nameCustomer: '',
        memberId: '',
        points: ''
      },
      rules: {
        required: (value) => !!value || 'กรุณากรอก.',
        nonNegative: (value) =>
          parseInt(value) > 0 || 'ห้ามน้อยกว่าหรือเท่ากับ 0',
        file: (value) =>
          !!value ||
          'กรุณาอัปโหลดไฟล์อย่างน้อย 1 ไฟล์ โดยรองรับเฉพาะไฟล์ .pdf, .png, .jpeg และ .xls เท่านั้น.',
        empId: (value) => {
          const pattern = /^[a-zA-Z]{2}[0-9]{5}$/
          return (
            pattern.test(value) ||
            'อักษร [A-Z]: 2, ตัวเลข [0-9]: 5 ตัวอย่าง (AA12345).'
          )
        }
      },
      ProductExchangeRate: [],
      dataBranch: [],
      confirmBtn: true,
      cancelBtn: false,
      them: '',
      loadingAdd: false,
      loading: false,
      dataItemImport: [],
      dataItemImport2: [],
      columnsImport: [
        { text: 'เบอร์โทรศัพท์', value: 'เบอร์โทรศัพท์', align: 'center' },
        { text: 'ยอดค่าใช้จ่าย', value: 'ยอดค่าใช้จ่าย', align: 'center' },
        {
          text: 'สถานะสมาชิก',
          value: 'status',
          sortable: false,
          align: 'center'
        },
        {
          text: 'รหัสซ้ำ',
          value: 'statusDup',
          sortable: false,
          align: 'center'
        }
      ],
      columnsImport2: [
        { text: 'เบอร์โทรศัพท์', value: 'เบอร์โทรศัพท์', align: 'center' },
        { text: 'คะแนน', value: 'คะแนน', align: 'center' },
        {
          text: 'สถานะสมาชิก',
          value: 'status',
          sortable: false,
          align: 'center'
        },
        {
          text: 'หมายเหตุ',
          value: 'statusDup',
          sortable: false,
          align: 'center'
        }
      ],
      dataIm: [],
      importPoint: {
        productExchangeRateId: '',
        amount: '',
        masBranchID: ''
      },
      file: null,
      data: {},
      showScanner: false,
      scannedData: null,
      export_datas: [
        {
          เบอร์โทรศัพท์: 'เบอร์โทรศัพท์ 10หลัก ',
          ยอดค่าใช้จ่าย: 'ยอดค่าใช้จ่าย เช่น 100'
        }
      ],
      export_fields: {
        เบอร์โทรศัพท์: 'เบอร์โทรศัพท์',
        ยอดค่าใช้จ่าย: 'ยอดค่าใช้จ่าย'
      },
      export_datas2: [
        {
          เบอร์โทรศัพท์: 'รหัสพนักงาน',
          คะแนน: 'ระบุคะแนน'
        }
      ],
      export_fields2: {
        เบอร์โทรศัพท์: 'รหัสพนักงาน',
        คะแนน: 'คะแนน'
      },
      exportType: 'xlsx',
      exportWorksheet: 'WorkSheet',
      exportFileName: 'เอกสารนำเข้าข้อมูลเพื่อเพิ่มคะแนน.xlsx',
      exportFileName2: 'เอกสารนำเข้าข้อมูลเพื่อเพิ่มคะแนน(แบบระบุคะแนน).xlsx',
      datamulti_import: [],
      loadingImportPoint: false,
      checkSelectExchangeRate: false,
      checkSelectBranch: false,
      mask: '###-###-####'
    }
  },

  async mounted () {
    this.session = this.$session.getAll()
    // await this.getThem()
    // await this.hexToRgbA(this.them.slice(0, -2))
    await this.getProductExchangeRate()
    await this.getDataBranch()
    this.checkNotifyStatusAddcoin()
    this.sessionCheck()
  },
  methods: {
    exportToExcel () {
      const worksheet = XLSX.utils.json_to_sheet(this.export_datas2)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, this.exportWorksheet)

      // สร้างไฟล์ .xlsx
      XLSX.writeFile(workbook, this.exportFileName2)
    },
    exportToExcel1 () {
      const worksheet = XLSX.utils.json_to_sheet(this.export_datas)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, this.exportWorksheet)

      // สร้างไฟล์ .xlsx
      XLSX.writeFile(workbook, this.exportFileName)
    },
    checkDupOrnotfimd () {
      return this.dataItemImport.some(
        (item) => item.status === 'False' || item.statusDup === 'False'
      )
    },
    checkDup () {
      return this.dataItemImport.some(item =>
        item.statusDup === 'False'
      )
    },
    checkDupNotdecress () {
      return this.dataItemImport.some(item =>
        Number(item.ยอดค่าใช้จ่าย) <= 0
      )
    },
    checkDupNotdecress2 () {
      return this.dataItemImport.some(item =>
        Number(item.คะแนน) <= 0
      )
    },
    checkDupNotdecress3 () {
      return this.dataItemImport.some(item =>
        !item.คะแนน
      )
    },
    checkDupNotdecress4 () {
      return this.dataItemImport.some(item =>
        !item.ยอดค่าใช้จ่าย
      )
    },
    sessionCheck () {
      if (this.$session.getAll().data.masBranchID !== null || '') {
        this.formAdd.masBranchID = parseInt(
          this.$session.getAll().data.masBranchID
        )
      } else {
        this.formAdd.masBranchID = ''
      }
      if (this.$session.getAll().data.productExchangeRateId !== null || '') {
        this.formAdd.productExchangeRateId = parseInt(
          this.$session.getAll().data.productExchangeRateId
        )
      }
    },
    checkNotifyStatusAddcoin () {
      try {
        if (
          this.$session.getAll().data.notify_status_addcoin.toLowerCase() ===
          'true'
        ) {
          this.statusnotifyAddcoin = true
        } else {
          this.statusnotifyAddcoin = false
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    async updateStatusnotifyAddcoin () {
      if (this.statusnotifyAddcoin === true) {
        this.dataNew = this.$session.getAll().data
        this.dataNew.notify_status_addcoin = 'True'
      } else {
        this.dataNew = this.$session.getAll().data
        this.dataNew.notify_status_addcoin = 'False'
      }
      localStorage.setItem('data', JSON.stringify(this.dataNew))
      this.$session.set('data', this.dataNew)
      this.checkNotifyStatusAddcoin()
      const DT = {
        notify_status_addcoin: this.statusnotifyAddcoin
      }
      await axios
        .post(
          this.DNS_IP +
          '/system_shop/edit/' +
          this.$session.getAll().data.shopId,
          DT
        )
        .then((res) => {
          console.log('this.them', res)
        })
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
          '/productExchangeRate/get?shopId=' +
          this.$session.getAll().data.shopId +
          '&changePointTodiscount_null=null'
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            s.allData = d
            this.ProductExchangeRate.push(s)
          }
          if (this.ProductExchangeRate.length === 1) {
            this.formAdd.productExchangeRateId =
              this.ProductExchangeRate[0].value
            this.formAdd.name = this.ProductExchangeRate[0].text
          } else {
            var a = this.ProductExchangeRate.filter((el) => {
              if (
                el.value === this.$session.getAll().data.productExchangeRateId
              ) {
                return el
              }
            })
            if (a.length > 0) {
              this.formAdd.productExchangeRateId = a[0].value
              this.formAdd.name = a[0].text
            }
            // console.log('f')
          }
        })
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    onBranchChange (val) {
      const b = this.dataBranch.find(d => d.value === val)
      this.formAdd.branchName = b ? b.text : ''
    },
    async getDataBranch () {
      this.dataBranch = []
      await axios
        .get(
          this.DNS_IP +
          '/master_branch/' +
          'get?shopId=' +
          this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            s.allData = d
            this.dataBranch.push(s)
          }
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = this.dataBranch[0].value
            this.formAdd.branchName = this.dataBranch[0].text
          }
        })
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.resetValidation()
    },
    async addData () {
      if (this.$refs.form.validate() === true) {
        await axios
          .get(
            this.DNS_IP +
            '/member/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&tel=' +
            this.formAdd.tel.split('-').join('').trim()
          )
          .then(async (result) => {
            if (result.data.status === false) {
              this.$swal(
                'ไม่พบบัญชีผู้ใช้',
                'กรุณาตรวจสอบหมายเลขโทรศัพท์',
                'error'
              )
              this.confirmBtn = true
              this.clearProfile()
            } else {
              console.log('result.data', result.data[0])
              this.profile = true
              if (result.data[0].pictures !== '') {
                this.formProfile.picture = result.data[0].picture
              } else {
                this.formProfile.picture =
                  'https://cdn.vuetifyjs.com/images/cards/cooking.png'
              }
              let a = this.ProductExchangeRate.filter(
                (el) => el.value === this.formAdd.productExchangeRateId
              )
              console.log('this.formProfile >>', result.data[0].pointPersen)
              if (result.data[0].pointPersen) {
                let amountData = parseInt(this.formAdd.amount)
                console.log('amount old >>>', amountData / a[0].exchangeRate)
                console.log('amount old >>>', amountData)
                let cvPersen = result.data[0].pointPersen / 100
                console.log('cvPersen >>>', cvPersen)
                let sumPoints = cvPersen * this.formAdd.amount
                console.log('sumPoints >>>', sumPoints)
                this.formProfile.points = Math.floor(
                  (amountData + sumPoints) / a[0].exchangeRate
                )
              } else {
                this.formProfile.points = Math.floor(
                  this.formAdd.amount / a[0].exchangeRate
                )
              }
              console.log(
                'this.formProfile.points >>>',
                this.formProfile.points
              )
              // console.log('points', a[0].allData)
              this.formProfile.picture = result.data[0].picture
              this.formProfile.name = result.data[0].name
              this.formProfile.tel = result.data[0].tel
              this.formProfile.point = result.data[0].currentPoint
              this.formProfile.totalPoint = result.data[0].collectPoint
              this.formProfile.LevelName = result.data[0].LevelName
              this.formProfile.nameCustomer = result.data[0].nameCustomer
              this.formProfile.memberId = result.data[0].memberId
              if (a[0].allData.multiplyPoint) {
                let startDate = new Date(
                  a[0].allData.startMultiplyPoint
                ).setHours(0, 0, 0, 0)
                let endDate = new Date(a[0].allData.endMultiplyPoint).setHours(
                  0,
                  0,
                  0,
                  0
                )
                var todaysDate = new Date().setHours(0, 0, 0, 0)
                if (startDate <= todaysDate && endDate >= todaysDate) {
                  this.multiplyPoint = a[0].allData.multiplyPoint
                  this.formProfile.points =
                    this.formProfile.points * this.multiplyPoint
                }
              }
              console.log(result.data)
            }
            await axios
              .get(
                this.DNS_IP +
                '/Log_FriendGetFriend/get?shopId=' +
                this.$session.getAll().data.shopId +
                '&inviteTo=' +
                result.data[0].memberId
              )
              .then(async (res) => {
                // console.log('Log_FriendGetFriend', res.data[0])
                if (res.data.status !== false) {
                  console.log('fffff', res.data[0].inviteFrom)
                  await axios
                    .get(
                      this.DNS_IP +
                      '/member/get?shopId=' +
                      this.$session.getAll().data.shopId +
                      '&memberId=' +
                      res.data[0].inviteFrom
                    )
                    .then((response) => {
                      console.log('response', response.data[0])
                      this.inviterData = response.data[0]
                      this.showInviter = true
                    })
                }
              })
              .catch((error) => console.log(error))
          })
      }
    },
    async confirm () {
      try {
        let data = {}
        this.loadingAdd = true
        let params = new FormData()
        params.append('file', this.uploadedFile)
        if (this.selectedReferenceNumber === 2) {
          try {
            const response = await axios.post(
              this.DNS_IP + `/file/upload/addcoin`,
              params
            )
            console.log('response', response.data.url)
            this.picture = response.data.url
          } catch (error) {
            console.error('Error uploading file:', error)
            return
          }
        }

        data = {
          refId: this.formAdd.refId,
          shopId: this.$session.getAll().data.shopId,
          tel: this.formAdd.tel.split('-').join('').trim(),
          Amount: this.formAdd.amount,
          exchangRateId: this.formAdd.productExchangeRateId.toString(),
          masBranchID: this.formAdd.masBranchID,
          branchName: this.formAdd.branchName,
          employee: this.$session.getAll().data.displayName,
          employeeId: this.$session.getAll().data.userId,
          memberId: this.formProfile.memberId,
          source: false
        }
        if (this.picture) {
          data.file_data = this.picture
        }
        console.log('data', data)
        axios.post(this.DNS_IP + '/POSapi', data).then((response) => {
          console.log('POSapi"', response)
          if (response.data.status === true) {
            this.$swal('เรียบร้อย', 'เพิ่มคะแนนเรียบร้อย', 'success')
            this.clear()
            this.reset()
            this.getProductExchangeRate()
            this.getDataBranch()
            this.loadingAdd = false
          } else {
            this.$swal(
              'แจกคะแนนไม่สำเร็จ',
              `${response.data.message}`,
              'error'
            )
            this.clear()
            this.reset()
            this.getProductExchangeRate()
            this.getDataBranch()
            this.loadingAdd = false
            console.log('fff===>4')
          }
          this.loadingAdd = false
          this.selectedReferenceNumber = 1
        })
      } catch (error) { }
    },
    clear () {
      this.selectedReferenceNumber = 1
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = ''
      this.formAdd.tel = ''
      this.formAdd.masBranchID = ''
      this.formAdd.refId = ''
      this.formAdd.point = ''
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.qrCodeURL = ''
      this.formAdd.CREATE_DATE = ''
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
      this.confirmBtn = true
      this.inviterData = null
      this.showInviter = false
    },
    clearProfile () {
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
    },
    async addCoin () {
      try {
        if (this.$refs.form.validate() === true) {
          this.loading = true
          await axios
            .get(
              this.DNS_IP +
              '/member/get?shopId=' +
              this.$session.getAll().data.shopId +
              '&tel=' +
              this.formAdd.tel.split('-').join('').trim()
            )
            .then((result) => {
              console.log('result.data', result.data)

              if (result.data.status === false) {
                this.$swal(
                  'ไม่พบบัญชี !',
                  'กรุณาตรวจสอบหมายเลขโทรศัพท์',
                  'error'
                )
                this.loading = false
              } else {
                let newName = ''
                let newPoint = ''
                if (result.data[0].nameCustomer === '') {
                  newName = result.data[0].name
                } else {
                  newName = result.data[0].nameCustomer
                }
                if (this.ProductExchangeRate.length > 1) {
                  var cc = this.ProductExchangeRate.filter(
                    (el) => el.value === this.formAdd.productExchangeRateId
                  )
                  var a = cc[0]
                } else {
                  a = this.ProductExchangeRate[0].exchangeRate
                  console.log('aaa', a)
                }
                newPoint = Math.floor(
                  parseInt(this.formAdd.amount) / a.exchangeRate
                )
                console.log('ffff', newPoint)
                this.$swal({
                  title: 'ต้องการเพิ่มคะแนน?',
                  html:
                    'คุณ' + newName + '<br>เพิ่มคะแนน ' + newPoint + ' คะแนน',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#1b437c',
                  cancelButtonColor: '#da484f',
                  confirmButtonText: 'ยืนยัน',
                  cancelButtonText: 'ยกเลิก',
                  closeOnConfirm: false
                })
                  .then((response) => {
                    var data = {
                      refId: this.formAdd.refId,
                      shopId: this.$session.getAll().data.shopId,
                      tel: this.formAdd.tel.split('-').join('').trim(),
                      Amount: this.formAdd.amount,
                      exchangRateId:
                        this.formAdd.productExchangeRateId.toString(),
                      masBranchID: this.formAdd.masBranchID,
                      branchName: this.formAdd.branchName,
                      employee: this.$session.getAll().data.displayName,
                      employeeId: this.$session.getAll().data.userId,
                      source: false
                    }
                    console.log('dataaaaaaaaa', data)
                    axios
                      .post(this.DNS_IP + '/POSapi', data)
                      .then((response) => {
                        console.log('POSapi"', response)
                        this.loading = false
                        this.$swal(
                          'เรียบร้อย',
                          'เพิ่มเหรียญเรียบร้อย',
                          'success'
                        )
                        this.clear()
                        this.reset()
                        this.getProductExchangeRate()
                        this.getDataBranch()
                        this.sessionCheck()
                      })
                  })
                  .catch(() => {
                    this.loading = false
                  })
              }
            })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async importData (event) {
      this.dataItemImport = []
      var input = event.target
      var reader = new FileReader()
      reader.onload = async () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })

        for (const sheetName of wb.SheetNames) {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])

          const rows = []
          for (var i = 0; i < rowObj.length; i++) {
            var d = rowObj[i]
            let expense = parseFloat(d['ยอดค่าใช้จ่าย'])
            let pointByMobile = parseFloat(d['คะแนน'])
            if ((!pointByMobile || pointByMobile <= 0) && (!expense || expense <= 0)) continue
            rows.push(d)
          }

          const members = await this.findMembersByTels(
            rows.map((row) => row.เบอร์โทรศัพท์)
          )

          rows.forEach((d, index) => {
            let isExist = members.some((member) =>
              this.sameMemberTel(member.tel, d.เบอร์โทรศัพท์)
            )
            if (index > 0) {
              let isExist2 = this.dataItemImport.some(
                (member) => member.เบอร์โทรศัพท์ === d.เบอร์โทรศัพท์
              )
              d.statusDup = isExist2 ? 'False' : 'True'
            }
            d.status = isExist ? 'True' : 'False'
            this.dataItemImport.push(d)
          })
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataPoint () {
      this.dataIm = []
      if (this.$refs.form.validate() === true) {
        this.$swal({
          title: 'ต้องการนำเข้าคะแนนใช่หรือไม่',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        }).then((res) => {
          this.dataItemImport.map((a) => {
            return a.status === 'True' ? this.dataIm.push(a) : null
          })
          console.log('ffff', this.dataIm)
          this.dataIm.map((e) => {
            this.data = {
              refId: null,
              shopId: this.$session.getAll().data.shopId,
              tel: e.tel,
              Amount: this.importPoint.amount,
              exchangRateId: this.importPoint.productExchangeRateId.toString(),
              masBranchID: this.importPoint.masBranchID,
              branchName: null,
              source: false
            }
            axios.post(this.DNS_IP + '/POSapi', this.data).then((response) => {
              console.log('POSapi"', response)

              // this.clearDataImp()
            })
          })

          //   axios.post(this.DNS_IP + '/POSapi', this.data).then(response => {
          //     console.log('POSapi"', response)

          this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
          this.clearDataImp()
          //   })
        })
      }
    },
    submitpoint () {
      this.dataIm = []
      this.body = []

      if (this.$refs.form.validate() === true) {
        this.$swal({
          title: 'ต้องการนำเข้าคะแนนใช่หรือไม่',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        }).then((res) => {
          this.dataItemImport.map((a) => {
            if (
              this.$session.getAll().data.shopId ===
              this.shopNameData.SHOP_ID_CHUBB
            ) {
              this.dataIm.push(a)
            } else {
              return a.status === 'True' ? this.dataIm.push(a) : null
            }
          })
          console.log('new data', this.dataIm)
          this.dataIm.map((e) => {
            this.data = {
              tel: e.เบอร์โทรศัพท์,
              shopId: this.$session.getAll().data.shopId,
              exchangRateId: this.importPoint.productExchangeRateId.toString(),
              Amount: e.ยอดค่าใช้จ่าย,
              masBranchID: this.importPoint.masBranchID,
              employee: this.$session.getAll().data.displayName,
              employeeId: this.$session.getAll().data.userId
            }
            console.log('ดาต้า', this.data)
            this.body.push(this.data)
          })
          console.log('body', this.body)
          axios
            .post(this.DNS_IP + '/posMultiple', this.body)
            .then((response) => {
              console.log('posMultiple"', response)
            })
          this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
          this.clearDataPoint()
        })
      }
    },
    submitpointFixPoint () {
      this.dataIm = []
      this.body = []
      if (this.$refs.form.validate() === true) {
        this.$swal({
          title: 'ต้องการนำเข้าคะแนนใช่หรือไม่ ?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        }).then((res) => {
          console.log('ffss >>', this.dataItemImport)
          this.dataItemImport.map((a) => {
            return a.status === 'True' ? this.dataIm.push(a) : null
          })
          console.log('new data', this.dataIm)
          this.dataIm.map((e) => {
            this.data = {
              tel: e.เบอร์โทรศัพท์,
              shopId: this.$session.getAll().data.shopId,
              Point: e.คะแนน,
              masBranchID: this.importPoint.masBranchID,
              employee: this.$session.getAll().data.displayName,
              employeeId: this.$session.getAll().data.userId
            }
            console.log('ดาต้า', this.data)
            this.body.push(this.data)
          })
          console.log('body', this.body)
          axios
            .post(this.DNS_IP + '/posMultiple/point', this.body)
            .then((response) => {
              console.log('posMultiple"', response)
            })
          this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
          this.dialogimportPointFixPoint = false
          this.clearDataPoint()
        })
      }
    },
    clearDataImp () {
      this.importPoint.productExchangeRateId = ''
      this.importPoint.amount = ''
      this.importPoint.masBranchID = ''
      this.dialogImport = false
      this.dataItemImport = []
    },
    clearDataPoint () {
      this.importPoint.productExchangeRateId = ''
      this.importPoint.amount = ''
      this.importPoint.masBranchID = ''
      this.dialogimportPoint = false
      this.dataItemImport = []
      this.$refs.fileInput.value = ''
    },
    scanQrcodePhoneNumber () {
      this.showScanner = true
    },
    stopScan () {
      this.showScanner = false
    },
    onDecode (a) {
      if (a) {
        this.formAdd.tel = a
        this.showScanner = false
      }

      // this.scannedData = decodedData
    },
    triggerFileInput () {
      this.$refs.fileInput.$el.querySelector('input[type="file"]').click()
    }
  }
}
</script>
<style scoped>
.padding-colH {
  padding: 5px 15px 0px;
}

.v-text-field {
  padding: 0px 16px 0px !important;
}

.red {
  color: red;
}

div.container4 {
  height: 14em;
  display: flex;
  align-items: center;
  justify-content: center;
}

div.container4 p {
  margin: 0;
}

/* style */
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #f2f4f7;
}

@media screen and (min-width: 320px) {

  /* smartphones, iPhone, portrait 480x320 phones */
  div .div1 {
    width: 100%;
    height: 180px;
    /* display: flex;
      align-items: center;
      justify-content: center; */
  }

  div h3 {
    font-size: 16px !important;
  }

  h2.text-h {
    /* font-family: 'Poppins'; */
    font-style: normal;
    font-weight: 600;
    font-size: 24px !important;
    line-height: 160%;
    color: #667085;
  }
}

@media screen and (min-width: 481px) {

  /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
  div h3 {
    font-size: 14px !important;
  }
}

@media screen and (min-width: 641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
}

@media screen and (min-width: 961px) {
  /* tablet, landscape iPad, lo-res laptops ands desktops */
}

@media screen and (min-width: 1025px) {
  /* big landscape tablets, laptops, and desktops */
}

@media screen and (min-width: 1281px) {
  /* hi-res laptops and desktops */
}

.laser {
  width: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/AddCoin.vue